import standard from './standard';
import standardFXMERIDIAN from './standardFXMERIDIAN';
import standardPIPS24 from './standardPIPS24';

export const themes = {
        standard, standardFXMERIDIAN, standardPIPS24
};

export type Themes = keyof typeof themes;

export * from './type';
